import {AfterViewChecked, AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DataService} from '../../services/data.service';
import {SpinnerService} from '../../services/spinner.service';
import SignaturePad from 'signature_pad';
import {MaterialModel} from '../../models/collected-data-model';
import {TemperatureSensorOptionEnum} from '../../enums/temperature-sensor-option-enum';
import {TemperatureSensorNameEnum} from '../../enums/temperature-sensor-name-enum';
import {PumpSensorNameEnum} from '../../enums/pump-sensor-name-enum';
import {CounterSensorNameEnum} from '../../enums/counter-sensor-name-enum';
import {DatePipe, formatNumber} from '@angular/common';
import {PumpSensorHelperModel} from '../../models/pump-sensor-helper-model';
import {NgForm, NgModel} from '@angular/forms';
import {InfoModalComponent} from '../info-modal/info-modal.component';
import {MeterSensorModel} from '../../models/meter-sensor-model';
import {DeviceDataService} from '../../services/device-data.service';
import {Subscription} from 'rxjs';
import {AlertService} from '../../services/alert.service';
import {AvailableSite} from '../../models/customer-model';
import {OtherSensorModel} from '../../models/other-sensor.model';
import {MeterTypeEnum} from '../../models/meter-type.enum';
import {IDeviceData} from '../../interfaces/juconnGateway.response';
import {PfcSensorOptionsEnum} from '../../enums/pfc-sensor-options.enum';
import {PfcSensorNameEnum} from '../../enums/pfc-sensor-name.enum';
import {ShareService} from '../../services/share.service';
import {Dialog, DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {TemperatureSensorHelperModel} from '../../models/temperature-sensor-helper-model';
import {PumpSensorModel} from '../../models/pump-sensor-model';
import {PressureSensorModel} from '../../models/perssure-sensor-model';
import {PfcSensorModel} from '../../models/pfc-sensor.model';
import {Utils} from "../../utils/utils";
import {AVAILABLE_TECHNICIANS} from "../../constants/technicians.constants";
import {OtherSensorOptionEnum} from '../../enums/other-sensor-option-enum';
import {PromptDialogComponent, PromptDialogResult} from "../prompt-dialog/prompt-dialog.component";
import {InstallationSubmissionData} from '../../models/installation-submission-data';
import {Router} from "@angular/router";

@Component({
  selector: 'app-preview-modal',
  templateUrl: './preview-modal.component.html',
  styleUrls: ['./preview-modal.component.scss']
})
export class PreviewModalComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {

  public technicianEmail: string;
  public installationAt: string;
  public maxIntallationDate: string;
  public verificationSuccessful: boolean;
  public installationInSeveralRooms: boolean;
  public signature: string;
  public signImage: string;
  public signImageRaw: any;
  public signatureDate: string;
  public commissioningMaterial: MaterialModel;
  public selectedSite: AvailableSite;

  public deviceData: IDeviceData;
  public isLoading = false;
  public hasError = false;
  public refreshButtonClicked = false;
  public siteOptions: AvailableSite[];

  get temperatureSensors(): TemperatureSensorHelperModel[] {
    return this.shareService.sensorsTemperature?.temperatureSensorsHelperList ?? [];
  }

  get pumpSensors(): PumpSensorHelperModel[] {
    return this.shareService.sensorsPump?.pumpSensors ?? [];
  }

  get meterSensors(): MeterSensorModel[] {
    return this.shareService.sensorsCounter?.counterSensors ?? [];
  }

  get otherSensors(): OtherSensorModel[] {
    return this.shareService.sensorsOther?.otherSensors ?? [];
  }

  get pressureSensors(): PressureSensorModel[] {
    return this.shareService.sensorsOther?.pressureSensors ?? [];
  }

  get pfcSensors(): PfcSensorModel[] {
    return this.shareService.sensorsOther?.pfcSensors ?? [];
  }

  public availableTechnicians = AVAILABLE_TECHNICIANS;

  @ViewChild('signaturePad') signaturePadElement: any;

  private signaturePad: SignaturePad;
  public signPadWidth = 600;
  public signPadHeight = 400;
  public isSignPadVisible = false;
  public showSignatureError: boolean;

  private deviceDataSub: Subscription;
  private generalGatewaySub: Subscription;

  constructor(
    private dialogRef: DialogRef<'REFRESH_GATEWAY_DATA' | null>,
    @Inject(DIALOG_DATA) private data: { deviceData: IDeviceData },
    private dataService: DataService,
    private spinnerService: SpinnerService,
    private deviceDataService: DeviceDataService,
    private alertService: AlertService,
    public shareService: ShareService,
    private dialog: Dialog,
    private router: Router,
  ) {
    this.deviceData = this.data.deviceData || {} as IDeviceData;

    this.deviceDataSub = this.deviceDataService.deviceData$.subscribe((data) => {
      if (data) {
        this.isLoading = data.isLoading;
        this.hasError = data.hasError;
      }
    });

    this.generalGatewaySub = this.shareService.generalGateway$.subscribe(generalGateway => {
      if (!generalGateway.additionalGateway && generalGateway.selectedCustomer?.plannedSites?.length > 0) {
        generalGateway.selectedCustomer?.plannedSites.sort((a, b) => this.getSiteName(a).localeCompare(this.getSiteName(b)));
        this.siteOptions = generalGateway.selectedCustomer.plannedSites;
      }
      if (generalGateway.additionalGateway && generalGateway.selectedCustomer?.installedSites?.length > 0) {
        generalGateway.selectedCustomer?.installedSites.sort((a, b) => this.getSiteName(a).localeCompare(this.getSiteName(b)));
        this.siteOptions = generalGateway.selectedCustomer.installedSites;
      }
    });

    this.installationAt = new DatePipe('de_DE').transform(new Date(), 'yyyy-MM-dd');
    this.maxIntallationDate = new DatePipe('de_DE').transform(new Date(), 'yyyy-MM-dd');

    const commissioningMaterial = JSON.parse(JSON.stringify(this.shareService.generalMeasurement.installationMaterial)) as MaterialModel;
    commissioningMaterial.materialType = 'COMMISSIONING';
    this.commissioningMaterial = commissioningMaterial;
  }

  ngAfterViewInit() {
    document.getElementById('modal-content').scrollTo(0, 0);
  }

  ngAfterViewChecked(): void {
    if (this.signaturePadElement && !this.signaturePad) {
      this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
      this.signaturePad.addEventListener('endStroke', () => {
        this.saveSignPadZoomed();
      });
    }
  }

  async ngOnInit(): Promise<void> {
    const installationData = await this.dataService.getGatewayBySerialNumber(
      this.deviceDataService.getDevice().readInfo.configInfo.locationID
    );
    if (installationData) {
      this.technicianEmail = installationData.technicianEmail;
      if (installationData.installationAt) {
        this.installationAt = new DatePipe('de_DE').transform(installationData.installationAt, 'yyyy-MM-dd');
      }
    }

    // Temperature flow/return check
    if (this.temperatureSensors.length > 0) {
      console.log(this.temperatureSensors)
      const hasFlowReturnError = this.temperatureSensors.some(sensor => {
        if (sensor.name?.includes(TemperatureSensorOptionEnum.FLOW_TEMP)) {
          return sensor.value < sensor.value2;
        }
        return false;
      });
      if (hasFlowReturnError) {
        this.alertService.error('Achtung! Vorlauftemperatur < Rücklauftemperatur.');
      }
    }

    if (!this.isLightSensorValid()) {
      this.alertService.error('Der Lichtsensor-Wert muss < 100 sein.');
    }
  }

  ngOnDestroy(): void {
    this.deviceDataSub.unsubscribe();
    this.generalGatewaySub.unsubscribe();
  }

  closeModal() {
    this.dialogRef.close();
  }

  saveSignPadZoomed() {
    this.signImage = this.signaturePad.toDataURL();
    this.signImageRaw = this.signaturePad.toData();
    if (this.signImage) {
      this.showSignatureError = false;
    }
  }

  async onGatewayRefreshBtnClicked() {
    this.refreshButtonClicked = true;
    await this.deviceDataService.reloadDeviceData();
    Utils.initPumpSensorIds(this.deviceDataService.getDeviceData().deviceData);
    this.refreshButtonClicked = false;
  }

  getTemperatureSensorName(name: string) {
    let typePortion = name;
    let outputSuffix = '';
    if (name.includes('-')) {
      const pairSplit = typePortion.split('-');
      typePortion = pairSplit[0];
      pairSplit[1] = '-' + pairSplit[1];
      if (pairSplit[1] === TemperatureSensorOptionEnum.FLOW_TEMP) {
        outputSuffix = TemperatureSensorNameEnum.FLOW_TEMP;
      } else if (pairSplit[1] === TemperatureSensorOptionEnum.RETURN_TEMP) {
        outputSuffix = TemperatureSensorNameEnum.RETURN_TEMP;
      } else if (pairSplit[1] === TemperatureSensorOptionEnum.FRESH_WATER_TEMP) {
        outputSuffix = TemperatureSensorNameEnum.FRESH_WATER_TEMP;
      }
    }
    const arraySplit = typePortion.split('_');
    const index = arraySplit[arraySplit.length - 1];
    arraySplit.splice(arraySplit.length - 1, 1);
    typePortion = arraySplit.join('_');
    let outputPrefix = '';
    switch (typePortion) {
      case TemperatureSensorOptionEnum.WARM_WATER_TEMP_CIRCULATION:
        outputPrefix = TemperatureSensorNameEnum.WARM_WATER_TEMP_CIRCULATION;
        break;
      case TemperatureSensorOptionEnum.WARM_WATER_TEMP_BUFFER:
        outputPrefix = TemperatureSensorNameEnum.WARM_WATER_TEMP_BUFFER;
        break;
      case TemperatureSensorOptionEnum.WARM_WATER_TEMP_BOILER:
        outputPrefix = TemperatureSensorNameEnum.WARM_WATER_TEMP_BOILER;
        break;
      case TemperatureSensorOptionEnum.WARM_WATER_TEMP_SOLAR:
        outputPrefix = TemperatureSensorNameEnum.WARM_WATER_TEMP_SOLAR;
        break;
      case TemperatureSensorOptionEnum.FRESH_WATER_STATION_PRIMARY:
        outputPrefix = TemperatureSensorNameEnum.FRESH_WATER_STATION_PRIMARY;
        break;
      case TemperatureSensorOptionEnum.WARM_WATER_TEMP_OUTLET:
        outputPrefix = TemperatureSensorNameEnum.WARM_WATER_TEMP_OUTLET;
        break;
      case TemperatureSensorOptionEnum.CUSTOM_WATER:
        outputPrefix = TemperatureSensorNameEnum.CUSTOM_WATER;
        break;
      case TemperatureSensorOptionEnum.HEATER_CL:
        outputPrefix = TemperatureSensorNameEnum.HEATER_CL;
        break;
      case TemperatureSensorOptionEnum.HEATER_BL:
        outputPrefix = TemperatureSensorNameEnum.HEATER_BL;
        break;
      case TemperatureSensorOptionEnum.HEATER_BL_SECONDARY:
        outputPrefix = TemperatureSensorNameEnum.HEATER_BL_SECONDARY;
        break;
      case TemperatureSensorOptionEnum.HEATER_DH_PRIMARY:
        outputPrefix = TemperatureSensorNameEnum.HEATER_DH_PRIMARY;
        break;
      case TemperatureSensorOptionEnum.HEATER_DH_SECONDARY:
        outputPrefix = TemperatureSensorNameEnum.HEATER_DH_SECONDARY;
        break;
      case TemperatureSensorOptionEnum.HEATER_SL_PRIMARY:
        outputPrefix = TemperatureSensorNameEnum.HEATER_SL_PRIMARY;
        break;
      case TemperatureSensorOptionEnum.HEATER_SL_SECONDARY:
        outputPrefix = TemperatureSensorNameEnum.HEATER_SL_SECONDARY;
        break;
      case TemperatureSensorOptionEnum.HEATER_BLC:
        outputPrefix = TemperatureSensorNameEnum.HEATER_BLC;
        break;
      case TemperatureSensorOptionEnum.HEATER_BLC_SECONDARY:
        outputPrefix = TemperatureSensorNameEnum.HEATER_BLC_SECONDARY;
        break;
      case TemperatureSensorOptionEnum.HEATER_WHLC:
        outputPrefix = TemperatureSensorNameEnum.HEATER_WHLC;
        break;
      case TemperatureSensorOptionEnum.HEATER_WHLC_SECONDARY:
        outputPrefix = TemperatureSensorNameEnum.HEATER_WHLC_SECONDARY;
        break;
      case TemperatureSensorOptionEnum.HEATER_BRINE_LOOP:
        outputPrefix = TemperatureSensorNameEnum.HEATER_BRINE_LOOP;
        break;
      case TemperatureSensorOptionEnum.HEATER_HPL:
        outputPrefix = TemperatureSensorNameEnum.HEATER_HPL;
        break;
      case TemperatureSensorOptionEnum.HEATER_LH:
        outputPrefix = TemperatureSensorNameEnum.HEATER_LH;
        break;
      case TemperatureSensorOptionEnum.CUSTOM_LOOP:
        outputPrefix = TemperatureSensorNameEnum.CUSTOM_LOOP;
        break;
      case TemperatureSensorOptionEnum.COLLECTION_LOOP:
        outputPrefix = TemperatureSensorNameEnum.COLLECTION_LOOP;
        break;
    }
    return outputPrefix + index + outputSuffix;
  }

  getPumpSensorName(name: string) {
    const arraySplit = name.split('_');
    arraySplit.splice(arraySplit.length - 1, 1);
    return PumpSensorNameEnum[arraySplit.join('_').toUpperCase()];
  }

  getCounterSensorName(name: string) {
    return CounterSensorNameEnum[name.toUpperCase()];
  }

  getTemperatureSensorValue(value: number): string {
    if (Number.isFinite(value)) {
      return formatNumber(value, 'de_DE') + ' °C';
    }
    return '-';
  }

  getPumpSensorValue(sensor: PumpSensorModel | PumpSensorHelperModel) {
    if (Number.isFinite(sensor.value)) {
      return formatNumber(sensor.value, 'de_DE');
    }
    return '-';
  }

  getOtherSensorName(otherSensorType: OtherSensorOptionEnum): string {
    switch (otherSensorType) {
      case OtherSensorOptionEnum.LIGHT:
        return 'Licht';
      case OtherSensorOptionEnum.LEAKAGE_1:
        return 'Leckage 1';
      case OtherSensorOptionEnum.LEAKAGE_2:
        return 'Leckage 2';
      case OtherSensorOptionEnum.SHAFT_CONTACT_1:
        return 'Schachtkontakt 1';
      case OtherSensorOptionEnum.SHAFT_CONTACT_2:
        return 'Schachtkontakt 2';
      case OtherSensorOptionEnum.SWITCHABLE_OUTPUT_1:
        return 'Schaltbarer Ausgang 1';
      case OtherSensorOptionEnum.SWITCHABLE_OUTPUT_2:
        return 'Schaltbarer Ausgang 2';
    }
  }

  getPfcSensorName(name: string): string {
    const arraySplit = name.split('_');
    const index = arraySplit[arraySplit.length - 1];
    const typePortion = arraySplit.slice(0, -1).join('_') + '_';
    switch (typePortion) {
      case PfcSensorOptionsEnum.POTENTIAL_FREE_CONTACT:
        return PfcSensorNameEnum.POTENTIAL_FREE_CONTACT + index;
      default:
        return 'Unbekannter PFC-Sensor ' + index;
    }
  }

  showError(model: NgModel) {
    return model.control.touched && model.control.invalid;
  }

  openSignaturePad() {
    this.calculateSighPadZoomedSize();
    this.signaturePad.minWidth = this.signPadWidth / 700;
    this.signaturePad.maxWidth = this.signPadWidth / 250;
    if (this.signImageRaw) {
      this.signaturePad.fromData(this.signImageRaw);
    }
    this.isSignPadVisible = true;
  }

  calculateSighPadZoomedSize() {
    const vh = window.innerHeight;
    const vw = window.innerWidth;
    this.signPadWidth = vw < 700 ? vw : Math.round(vw * 0.8);
    if (this.signPadWidth < 700 && vw > 700) {
      this.signPadWidth = 700;
    }
    this.signPadHeight = Math.round(vh * 0.8);
    const rationedHeight = Math.round((this.signPadWidth / 288) * 130);
    if (vw > rationedHeight) {
      this.signPadHeight = rationedHeight;
    }
    if (this.signPadHeight < 206) {
      this.signPadHeight = 206;
    }
  }

  clearSignaturePad() {
    this.signaturePad.clear();
    this.signImage = null;
    this.signImageRaw = null;
  }

  closeSignaturePad() {
    this.isSignPadVisible = false;
  }

  getSignatureDate(): Date {
    return this.signImage ? new Date() : undefined;
  }

  async submit() {
    if (this.selectedSite.id !== this.shareService.generalGateway.selectedSite.id) {
      this.dialog.open(PromptDialogComponent, {
        data: {
          title: '',
          body: 'Adresse Montage und Adresse Installation stimmen nicht überein. Bitte bestätigen, dass es sich um die korrekte Adresse handelt: <b>' + this.getSiteName(this.selectedSite) + '</b>',
          confirmAction: 'Bestätigen und Absenden',
          cancelAction: 'Zurück',
          closeActionEnabled: true,
          hideHeader: true,
        }
      }).closed.subscribe((value) => {
        if (value === PromptDialogResult.OK) {
          this.shareService.generalGateway.selectedSite = this.selectedSite;
          this.sendInstallation();
        }
      });
    } else {
      await this.sendInstallation();
    }
  }

  async sendInstallation() {
    const signDate = this.getSignatureDate();
    if (signDate) {
      this.signatureDate = signDate.toISOString();
    }

    const submissionData: InstallationSubmissionData = {
      gatewayId: this.shareService.getGatewayId(),
      simIp: this.shareService.simIp,
      technicianEmail: this.technicianEmail,
      installationAt: new Date(this.installationAt).toISOString(),
      signatureDate: this.signatureDate,
      signImage: this.signImage,
      signature: this.signature,
      verificationSuccessful: this.verificationSuccessful,
      installationInSeveralRooms: this.installationInSeveralRooms,
      commissioningMaterial: this.commissioningMaterial,

      building: this.shareService.building,
      generalGateway: this.shareService.generalGateway,
      generalMeasurement: this.shareService.generalMeasurement,
      generalPrePhotos: this.shareService.generalPrePhotos,
      generalSending: this.shareService.generalSending,
      heatingCheck: this.shareService.heatingCheck,
      heatingInformation: this.shareService.heatingInformation,
      photos: this.shareService.photos,
      sensorsCounter: this.shareService.sensorsCounter,
      sensorsOther: this.shareService.sensorsOther,
      sensorsOutsideTemp: this.shareService.sensorsOutsideTemp,
      sensorsPump: this.shareService.sensorsPump,
      sensorsTemperature: this.shareService.sensorsTemperature,
    };

    try {
      this.spinnerService.showSpinner();
      await this.dataService.postData(submissionData, null);

      this.dialog.open(InfoModalComponent, {data: {isError: false}}).closed.subscribe(async (value) => {
        if (value === 'CLOSE') {
          this.shareService.resetAllData();
          await this.router.navigate(['/gateway/general/gateway']);
          this.dialogRef.close()
        }
      });
    } catch (e) {
      console.error(e);
      this.dialog.open(InfoModalComponent, {
        data: {
          isError: true,
          errorText: this.dataService.describePostDataError(e) + '\n\n' + JSON.stringify(e, null, 2)
        }
      }).closed.subscribe((value) => {
        if (value === 'DOWNLOAD') {
          const shortDate = new DatePipe('de_DE').transform(signDate, 'dd-MM-YYYY_HHmmss');
          this.downloadObjectAsJson(submissionData, 'gatewayData_' + submissionData.gatewayId + '_' + shortDate);
          this.closeModal();
        }
      });
    } finally {
      this.spinnerService.hideSpinner();
    }
  }

  private downloadObjectAsJson(exportObj: any, exportName: string) {
    const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(exportObj));
    const downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute('href', dataStr);
    downloadAnchorNode.setAttribute('download', exportName + '.json');
    document.body.appendChild(downloadAnchorNode);
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  isFormValid(): boolean {
    return this.isSignatureValid() && this.verificationSuccessful && this.isLightSensorValid() && !!this.technicianEmail;
  }

  private isSignatureValid(): boolean {
    if (this.signature || this.signImage) {
      return !!(this.signature && this.signImage);
    }
    return true;
  }

  checkForm(form: NgForm) {
    form.control.markAllAsTouched();
  }

  otherSectionHasContent() {
    return this.otherSensors?.length > 0;
  }

  pressureSectionHasContent() {
    return this.pressureSensors?.length > 0;
  }

  protected readonly MeterTypeEnum = MeterTypeEnum;

  public getSiteName(site: AvailableSite) {
    return `${site.street} ${site.streetNumber}, ${site.city} ${site.postCode}` +
      (site.additionalName ? ' - ' + site.additionalName : '');
  }

  getModule(moduleId) {
    return this.deviceData.uvsModule.find(module => module.moduleInfo.address === moduleId);
  }

  compareById(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }

  public installationDateChanged(date: any) {
    this.installationAt = date;
  }

  private isLightSensorValid(): boolean {
    let validity = true;
    this.otherSensors
      ?.filter(sensor => sensor.sensorType === OtherSensorOptionEnum.LIGHT)
      .forEach(sensor => {
        const uvsModules = this.deviceData?.uvsModule?.filter(
          module => module.moduleInfo.address.toString() === sensor.uvsModuleId.toString()
        );
        validity = validity && uvsModules?.length === 1 && uvsModules[0].light[0] < 100;
      });
    return validity;
  }
}
